export default "__VITE_ASSET__BwAmtMyb__"